
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1.2em","height":"1.2em","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M6 6v2h2V6zM5 4.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zM12 6v2h2V6zm-1-1.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zM6 12v2h2v-2zm-1-1.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M10.5 11a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M2 3a1 1 0 011-1h3.5a1 1 0 010 2H3a1 1 0 01-1-1","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M3 2a1 1 0 011 1v3.5a1 1 0 01-2 0V3a1 1 0 011-1m0 16a1 1 0 01-1-1v-3.5a1 1 0 112 0V17a1 1 0 01-1 1","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M2 17a1 1 0 011-1h3.5a1 1 0 110 2H3a1 1 0 01-1-1m16 0a1 1 0 01-1 1h-3.5a1 1 0 110-2H17a1 1 0 011 1","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M17 18a1 1 0 01-1-1v-3.5a1 1 0 112 0V17a1 1 0 01-1 1m0-16a1 1 0 011 1v3.5a1 1 0 11-2 0V3a1 1 0 011-1","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M18 3a1 1 0 01-1 1h-3.5a1 1 0 110-2H17a1 1 0 011 1","clip-rule":"evenodd"}})])])
          )
        }
      }
    